module.exports = __webpack_public_path__ + "img/20210630_202357.484753f2.jpg";